import {
    SideBarMenuItem,
    UserAreaMenuItem,
} from '../../types/sidebar.types';

const gatewayMenu: SideBarMenuItem[] = [
    {
        label: 'تراکنش ها',
        url: 'transaction',
        icon: <i className="fa-light fa-money-simple-from-bracket"></i>,
        active: true,
    },
    {
        label: 'تسویه حساب ها',
        url: 'withdraw',
        icon: <i className="fa-light fa-money-bill-transfer"></i>,
        active: true,
    },
    {
        label: 'تحلیل تراکنش ها',
        url: 'transaction-analytics',
        permissionKey: 'gateway-transaction-analytics-show',
        icon: <i className="fa-light fa-chart-mixed"></i>,
        active: true,
    },
    {
        label: 'تحلیل رفتار مشتری',
        url: 'customer-behavior-analytics',
        permissionKey: 'gateway-customer-behavior-analytics-show',
        icon: <i className="fa-light fa-users-viewfinder"></i>,
        active: true,
    },
    {
        label: 'دریافت گزارش بازه زمانی',
        url: 'range-report',
        permissionKey: 'gateway-range-report-export',
        icon: <i className="fa-light fa-file-chart-column"></i>,
        active: true,
    },
    // {
    //     label: 'فاکتور',
    //     url: 'invoice',
    //     icon: <i className="fa-light fa-receipt"></i>,
    //     active: true,
    // },
    // {
    //     label: 'فرم پرداخت',
    //     url: 'paymentForm',
    //     icon: <i className="fa-light fa-input-text"></i>,
    //     active: true,
    // },
    // {
    //     label: 'کد تخفیف',
    //     url: 'discount',
    //     icon: <i className="fa-light fa-tags"></i>,
    //     active: true,
    // },
    // {
    //     label: 'استرداد وجه',
    //     url: 'refund',
    //     icon: <i className="fa-light fa-tags"></i>,
    //     active: true,
    // },
];

const menus: SideBarMenuItem[] = [
    {
        label: 'حساب های بانکی',
        url: 'bank',
        icon: <i className="fa-light fa-credit-card-front"></i>,
    },
    {
        label: 'پشتیبانی',
        url: 'ticket',
        icon: <i className="fa-light fa-headset"></i>,
    },
    {
        label: 'بازاریابی',
        url: 'marketing',
        icon: <i className="fa-light fa-chart-simple"></i>,
    },
    {
        label: 'گزارش های فراخوانی',
        url: 'report',
        icon: <i className="fa-light fa-display-code"></i>,
    },
    {
        label: 'همراهان آقای پرداخت',
        url: 'partner',
        icon: <i className="fa-light fa-heart"></i>,
    },
];

const userAreaMenu: UserAreaMenuItem[] = [
    {
        url: '/profile/account',
        label: 'پروفایل',
        description: 'پروفایل خود را مشاهده کنید',
        icon: (
            <i
                className="fa-light fa-user-circle"
                style={{ fontSize: '18px' }}
            />
        ),
        iconSize: 'small',
    },
    {
        url: '/profile/security',
        label: 'تایید دومرحله ای',
        description: 'تایید دومرحله ای حساب را مدیریت کنید',
        icon: <i className="fa-light fa-shield-halved"></i>,
        iconSize: 'small',
    },
    {
        url: '/profile/active-sessions',
        label: 'نشست‌های فعال',
        description: 'ورودهای فعال حساب را مشاهده کنید',
        icon: <i className="fa-light fa-desktop"></i>,
        iconSize: 'small',
    },
    {
        url: '/profile/api-token',
        label: 'توکن وب سرویس',
        description: 'توکن وب سرویس را مدیریت کنید',
        icon: <i className="fa-light fa-key"></i>,
        iconSize: 'small',
    },
    {
        url: '/profile/wallets',
        label: 'کیف پول',
        description: 'کیف پول خود را را مدیریت کنید',
        icon: <i className="fa-light fa-wallet"></i>,
        iconSize: 'small',
    },
    {
        url: '/profile/notifications',
        label: 'تنظیمات اطلاع‌رسانی',
        description: 'رخداد های ارسالی را فعال کنید',
        icon: <i className="fa-light fa-bell"></i>,
        iconSize: 'small',
    },
    {
        url: '/profile/addresses',
        label: 'آدرس ها',
        description: 'آدرس های خود را مدیریت کنید',
        icon: <i className="fa-light fa-location-dot"></i>,
        iconSize: 'small',
    },
];

export { menus, gatewayMenu, userAreaMenu };
